__turbopack_context__.v({
  "className": "plus_jakarta_sans_907e0fd9-module__5opbEa__className",
});
